import { type OddsFormat } from '~/vendor/cx-web/domain-types';

import { convertDecimalOddsToProbability } from './odds-utils';
import { isPredictionMarket } from './prediction-markets';

export function getOddsByFormat(
  bet: {
    oddsAmerican: string;
    oddsDecimal: number;
    oddsFractional: string;
  },
  format: OddsFormat,
  bookmakerCode?: string,
): string {
  switch (format) {
    case 'decimal':
      return bet.oddsDecimal.toFixed(2);
    case 'fractional':
    case 'traditional':
      return bet.oddsFractional;
    case 'american':
      return isPredictionMarket(bookmakerCode) ? convertDecimalOddsToProbability(bet.oddsDecimal) : bet.oddsAmerican;
    default:
      return bet.oddsAmerican;
  }
}
